<div class="row">
	<div class="col-lg-12">
		<div class="card">
			<div class="card-header align-items-center d-flex">
				<h4 class="card-title mb-0 flex-grow-1">Edit User Employee</h4>
			</div>
			<div class="card-header align-items-center d-flex">
				<h4>
					<span
						class="badge"
						[ngClass]="{
							'badge-success': IsActive == 1,
							'badge-danger': IsActive == 0
						}"
					>
						<span *ngIf="IsActive == 1">Active</span>
						<span *ngIf="IsActive == 0">Inactived</span>
					</span>
					{{ first }} {{ last }}
				</h4>
			</div>
			<div class="card-body">
				<div class="page__menu menu">
					<ul ngbNav #nav="ngbNav" [activeId]="3" class="nav nav-tabs nav-tabs-custom nav-success mb-3">
						<li [ngbNavItem]="1">
							<a ngbNavLink class="menu__link r-link text-underlined">User Information</a>
							<ng-template ngbNavContent>
								<div class="col-md-12 ml-auto mr-auto">
									<div class="row">
										<div class="col-md-6 col-sm-6">
											<label class="normal_label" for="first_name">First Name</label>
											<input id="first_name" [(ngModel)]="userProfile.first" type="text" class="form-control" placeholder="First Name" />
										</div>
										<div class="col-md-6 col-sm-6">
											<label class="normal_label" for="last_name">Last Name</label>
											<input id="last_name" [(ngModel)]="userProfile.last" type="text" class="form-control" placeholder="Last Name" />
										</div>
									</div>
									<br />
									<div class="row">
										<div class="col-md-6 col-sm-6">
											<label class="normal_label" for="email">Email</label>
											<input id="email" [(ngModel)]="userProfile.email1" type="text" class="form-control" placeholder="Email" />
										</div>
										<div class="col-md-3 col-sm-3">
											<label class="normal_label" for="rc_ext">Ring Central Ext</label>
											<input id="rc_ext" disabled [(ngModel)]="userProfile.ringcentral_ext" type="text" class="form-control" placeholder="Ring Central Ext" />
										</div>
										<div class="col-md-3 col-sm-3">
											<label class="normal_label" for="rc_ext_id">Ring Central Extension ID</label>
											<input id="rc_ext_id" disabled [(ngModel)]="userProfile.rc_ext_id" type="text" class="form-control" placeholder="Ring Central Ext" />
										</div>
									</div>
									<br />
									<div class="row">
										<div class="col-12">
											<label for="" class="normal_label">Timezone</label>
											<select [(ngModel)]="timezone" class="form-control">
												<option value="{{ timezone.value }}" *ngFor="let timezone of timezones">
													{{ timezone.text }}
												</option>
											</select>
										</div>
									</div>
									<br />
									<div class="row">
										<div class="col-12" align="right">
											<button class="btn btn-success" (click)="saveUserInfo()">Save</button>
										</div>
									</div>
								</div>
							</ng-template>
						</li>

						<li [ngbNavItem]="2">
							<a ngbNavLink class="menu__link r-link text-underlined">Assign Campaigns</a>
							<ng-template ngbNavContent>
								<div *ngIf="userProfile" class="col-md-12 ml-auto mr-auto">
									<div class="row">&nbsp;</div>
									<div class="col-md-12 ml-auto mr-auto">
										<div class="row">
											<h4>
												<i class="ri-database-2-fill mr-4"></i>
												<small class="mr-3">{{ campaigns.length }} Campaign(s)</small>

												<button *ngIf="campaignsTab === 'unassigned' && campaigns && campaigns.length" class="btn btn-success" (click)="assignAllCampaignsConfirm()" ngbTooltip="Assign All Campaigns" style="margin-left: 5px">
													Assign All Campaigns
													<i class="ri-upload-2-fill"></i>
												</button>

												<button *ngIf="campaignsTab === 'assigned' && campaigns && campaigns.length" class="btn btn-danger" (click)="removeAllCampaignsConfirm()" ngbTooltip="Remove All Campaigns" style="margin-left: 5px">
													Remove All Campaigns
													<i class="ri-close-circle-fill red-cross"></i>
												</button>
											</h4>
											<div class="col-md-4 mt-4">
												<ul ngbNav #Pills="ngbNav" [activeId]="1" class="nav nav-pills nav-success mb-3">
													<li [ngbNavItem]="1" class="nav-item waves-effect waves-light">
														<span (click)="toggleCampaignList('assigned')" [class.active]="campaignsTab === 'assigned'" class="nav-link grey tab-btn tab-toggle active" role="tab" aria-expanded="true">
															Assigned
															<span class="badge badge-warning">{{ assignedCampaigns.length }}</span></span
														>
													</li>
													<li [ngbNavItem]="2" class="nav-item waves-effect waves-light">
														<span (click)="toggleCampaignList('unassigned')" [class.active]="campaignsTab === 'unassigned'" class="nav-link black tab-btn tab-toggle" role="tab" aria-expanded="false">
															Unassigned
															<span class="badge badge-warning">{{ unassignedCampaigns.length }}</span></span
														>
													</li>
												</ul>
											</div>
										</div>
									</div>
									<div class="table-responsive">
										<table class="table table-striped">
											<thead class="table-light">
												<tr>
													<th scope="col">#</th>
													<th scope="col">Assigned</th>
													<th scope="col">Name</th>
													<th scope="col">Alias</th>
													<th scope="col">Zone</th>
													<th scope="col">Needed</th>
													<th scope="col">Points</th>
													<th scope="col">Industry</th>
													<th scope="col">Type</th>
												</tr>
											</thead>
											<tbody>
												<!---->
												<tr *ngFor="let campaign of campaigns; let i = index" [attr.data-index]="i" class="ng-star-inserted grid-row">
													<td class="text-right">
														{{ i + 1 }}
													</td>
													<td class="form-check form-switch" *ngIf="campaign.isAssigned == 1">
														<input class="form-check-input" type="checkbox" role="switch" id="SwitchCheck2" checked (click)="removeCampaignConfirm(campaign)" />
													</td>
													<td class="form-check form-switch" *ngIf="campaign.isAssigned == 0">
														<input class="form-check-input" type="checkbox" role="switch" id="SwitchCheck2" (click)="assignCampaignConfirm(campaign)" />
													</td>
													<td
														class="label-bold campaign-name"
														[ngClass]="{
															'bg-dark': campaign.isAssigned == 0,
															'text-white': campaign.isAssigned == 0,
															'table-success': campaign.isAssigned == 1
														}"
													>
														{{ campaign.name }}
													</td>
													<td class="label-bold">
														{{ campaign.alias }}
													</td>
													<td class="label-bold">
														{{ campaign.zone }}
													</td>
													<td
														class="label-bold text-right"
														[ngClass]="{
															'bg-dark': campaign.isAssigned == 0,
															'text-white': campaign.isAssigned == 0,
															'table-success': campaign.isAssigned == 1
														}"
													>
														{{ campaign.leads_needed }}
													</td>
													<td class="label-bold text-right">
														{{ campaign.points }}
													</td>
													<td class="label-bold text-right">
														{{ campaign.industry }}
													</td>
													<td class="label-bold text-right">
														{{ campaign.type }}
													</td>
												</tr>
											</tbody>
											<tfoot class="table-light">
												<tr>
													<th class="text-center">
														{{ campaigns.length }}
													</th>
													<th>&nbsp;</th>
													<th>&nbsp;</th>
													<th>&nbsp;</th>
													<th>&nbsp;</th>
													<th>&nbsp;</th>
													<th>&nbsp;</th>
													<th>&nbsp;</th>
													<th>&nbsp;</th>
													<th>&nbsp;</th>
												</tr>
											</tfoot>
										</table>
									</div>
								</div>
							</ng-template>
						</li>

						<li [ngbNavItem]="3">
							<a ngbNavLink class="menu__link r-link text-underlined">Active Modules</a>
							<ng-template ngbNavContent>
								<app-auth-modules [selectedUser]="userProfileId" [isClient]="IsClient"></app-auth-modules>
							</ng-template>
						</li>
					</ul>
					<!-- Tab panes -->
					<div class="tab-content text-muted">
						<div [ngbNavOutlet]="nav"></div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
